import { useQuery } from '@tanstack/react-query';
import type { LinkedBankAccount } from '@repo/shared-types';
import { fetchApi } from '../lib/api';

export type BankAccount = LinkedBankAccount;

/** `GET /bank-accounts` is OWNER/ADMIN only (THI-136): pass `enabled` from
 *  `useCan('manage:settings')` wherever a MEMBER can render the caller, so the
 *  fetch is never made rather than 403-toasted (INVARIANTS §4.3). */
export function useBankAccounts(enabled = true) {
  return useQuery<BankAccount[]>({
    queryKey: ['bank-accounts'],
    queryFn: () => fetchApi<BankAccount[]>('/bank-accounts'),
    enabled,
  });
}
